import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';

const resources = {
  en: { translation: en },
  ru: { translation: ru },
};

// Get language from settings store, Telegram, or default to 'en'
const getInitialLanguage = (): string => {
  if (typeof window === 'undefined') return 'en';
  
  // Try to get from settings store (localStorage)
  // Zustand persist saves data directly, not nested in 'state'
  try {
    const settingsStr = localStorage.getItem('sudoku-settings-storage');
    if (settingsStr) {
      const settings = JSON.parse(settingsStr);
      // Zustand persist saves directly at root level
      if (settings?.language && (settings.language === 'ru' || settings.language === 'en')) {
        return settings.language;
      }
    }
  } catch (e) {
    // Ignore parse errors
  }
  
  // Fallback to Telegram language
  if (window.Telegram?.WebApp) {
    const tgLang = window.Telegram.WebApp.initDataUnsafe.user?.language_code;
    if (tgLang === 'ru') return 'ru';
  }
  
  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;


